module.exports = __webpack_public_path__ + "img/welding-4.80bc3f9f.jpg";